import {AbstractModel} from './abstract-model';

export class IpRule extends AbstractModel {
  id: number | null = null;
  position: number | null = null;
  name: string | null = null;
  type: string | null = null;
  ip: string | null = null;
  countryCode: string | null = null;
  allowed: boolean = false;
}
